import React, {useCallback, useState} from "react";
import {FormModal} from "../../components/index.jsx";
import {Images} from "../../images/Images.jsx";
import {ConfigProvider} from "antd";
import "./request-bid-correction-modal.css";

const {noteImage} = Images;

export const RequestBidCorrectionModal = ({visible, onClose, onSave, bidInfo}) => {
    const [isLoading, setIsLoading] = useState(false);

    const onFinish = useCallback(
        async correctionDetails => {
            setIsLoading(true);
            await onSave({
                ...correctionDetails,
                bidId: bidInfo?.bidId
            });
            setIsLoading(false);
        },
        [onSave, bidInfo]
    );

    return (
        <div>
            <ConfigProvider direction="rtl">
                <FormModal
                    className="request-bid-correction-modal-container"
                    image={noteImage}
                    header="בקשה לתיקון הצעת המחיר "
                    visible={visible}
                    onClose={onClose}
                    onSave={onFinish}
                    isConfirmButtonLoading={isLoading}
                    confirmButtonTitle="שליחה לבית העסק "
                    showCancelButton={false}
                    fields={[
                        {
                            name: "correctionDetails",
                            label: "תיאור הבקשה לתיקון",
                            type: "textarea",
                            placeholder: "הקלידו כאן את התיקונים המבוקשים...",
                            rules: [
                                {
                                    required: true,
                                    message: "יש להזין את תיאור הבקשה לתיקון"
                                }
                            ]
                        }
                    ]}
                />
            </ConfigProvider>
        </div>
    );
};
